module.exports = __webpack_public_path__ + "static/media/tooltip_career.f8bce3a1.svg";